<template>
  <div class="wrapper-header">
    <div id="header" v-if="!$store.getters.is_mobile_or_tablet" :class="color_theme_flag ? 'header-color-theme-dark' : ''">

      <div v-if="false" id="racoon-icon" class="cursor-pointer">
          <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.10899 20.9562L0.244995 18.8403L10.8076 22.1821C11.6808 22.8874 12.5373 22.7026 14.5524 22.6691C17.0881 22.6355 18.2972 22.2996 18.6666 21.863L28.9941 18.7563C28.4904 19.5624 27.1973 21.3424 26.3913 21.6111C25.5852 21.8798 21.068 23.643 17.4911 23.9453C15.0344 24.2106 13.8471 24.0964 11.2946 23.9285C8.75891 23.7774 4.8462 22.266 2.7807 21.4264C2.51201 21.3256 2.29371 21.1577 2.10899 20.9562Z" fill="#CFD0D1"/>
            <path d="M10.8748 22.1316L10.8412 22.1148L0.244995 18.8402C0.564057 15.0787 1.77313 8.10967 8.17116 3.62601C8.7757 3.2062 9.00923 3.11759 10 3.00004C10.9908 2.8825 12.7388 3 14.6699 3C14.8883 3 15.1234 3 15.3585 3C16.6011 2.98321 18.1125 2.68562 19.691 3.05506C22.1763 4.04583 27.5836 8.63025 29.0109 18.7731L18.6834 21.7957H18.6666H18.6498C18.5827 21.8461 18.5155 21.8965 18.4651 21.9469C18.4483 21.9637 18.4315 21.9805 18.4147 21.9973C18.3643 22.0308 18.3308 22.0644 18.2804 22.1148C18.146 22.2324 17.9781 22.3499 17.7094 22.4675C17.1889 22.7025 16.2653 22.6354 14.5524 22.6858C12.1342 22.7529 11.1267 22.3835 10.8748 22.1316Z" fill="#FAFAFA"/>
            <path d="M18.1458 16.4724C17.239 15.7671 15.9628 15.3137 14.5522 15.3137C14.5522 15.3137 14.5354 15.3137 14.5186 15.3137C13.0912 15.3137 11.815 15.7671 10.925 16.4724C10.0853 17.1441 9.56476 18.0341 9.56476 19.0081C9.56476 20.1836 9.95099 21.6278 11.0425 22.2995C11.4623 22.5514 11.8318 22.7361 12.4531 22.8369C13.0744 22.9376 13.7629 22.7865 14.3675 22.7865C14.4179 22.7865 14.485 22.7865 14.5522 22.7865C14.6026 22.7865 14.6697 22.7865 14.7201 22.7865C15.3247 22.7865 15.9964 22.9376 16.6177 22.8369C17.239 22.7361 17.6085 22.5514 18.0283 22.2995C19.1198 21.6278 19.506 20.1836 19.506 19.0081C19.506 18.0341 19.0023 17.1441 18.1458 16.4724Z" fill="#CFD0D1"/>
            <path d="M18.1409 16.4791C17.6707 16.1197 17.1384 15.846 16.5775 15.6663C16.015 15.4866 15.4289 15.3892 14.8412 15.3741C13.669 15.3439 12.4801 15.5924 11.4692 16.1835C10.9654 16.4774 10.512 16.8636 10.1661 17.3372C9.99479 17.574 9.85541 17.8326 9.75297 18.108C9.65222 18.3834 9.60184 18.6756 9.59344 18.9678C9.58337 19.5555 9.67404 20.1483 9.8722 20.7024C10.0687 21.2549 10.3945 21.7705 10.8613 22.1214C11.0947 22.291 11.3584 22.4321 11.6237 22.548C11.8924 22.6605 12.1762 22.7327 12.465 22.7764C13.0393 22.8586 13.6254 22.736 14.2232 22.7125C14.3743 22.7075 14.5221 22.7092 14.6699 22.7075C14.8193 22.7058 14.9705 22.7125 15.1199 22.7226C15.4172 22.7428 15.711 22.7763 16.0015 22.7831C16.2937 22.7931 16.5759 22.768 16.8613 22.7008C17.1435 22.6386 17.4138 22.5379 17.6707 22.4036C17.931 22.2675 18.1745 22.1164 18.3811 21.9166C18.5876 21.7184 18.7606 21.485 18.905 21.2348C19.1888 20.7293 19.3433 20.155 19.4189 19.574C19.4525 19.2835 19.4743 18.9879 19.4474 18.6974C19.4222 18.4069 19.3433 18.1197 19.2291 17.851C18.999 17.307 18.5994 16.8468 18.1409 16.4791ZM18.151 16.4656C18.6195 16.8284 19.0209 17.2885 19.2728 17.8309C19.3987 18.1013 19.4894 18.3901 19.5263 18.689C19.5633 18.9879 19.5532 19.2868 19.5314 19.5857C19.481 20.1802 19.3315 20.7747 19.0477 21.312C18.905 21.579 18.7236 21.8276 18.502 22.0392C18.282 22.2541 18.0184 22.417 17.7547 22.5564C17.4877 22.6991 17.1989 22.8066 16.9033 22.8721C16.6111 22.9426 16.2988 22.9728 15.9999 22.9577C15.6993 22.9476 15.4037 22.9107 15.1115 22.8872C14.8227 22.862 14.5255 22.867 14.2333 22.8687C13.6522 22.8872 13.0544 23.0014 12.4482 22.9023C12.1527 22.8519 11.8588 22.7713 11.5851 22.6487C11.3113 22.5228 11.0527 22.3767 10.8092 22.1936C10.3306 21.8192 10.0183 21.2801 9.82014 20.7209C9.62535 20.1567 9.5397 19.5605 9.53802 18.9661C9.54306 18.3666 9.75465 17.7772 10.0922 17.2835C10.4331 16.7897 10.8865 16.3766 11.4003 16.0643C12.4314 15.4413 13.6606 15.1928 14.8479 15.27C15.444 15.3069 16.0335 15.4262 16.5926 15.626C17.1502 15.8225 17.6842 16.0979 18.151 16.4656Z" fill="#5F6467"/>
            <path d="M6.74543 13.7974L11.5616 14.3885L6.17448 14.3717C6.00655 14.3717 5.85541 14.4221 5.73786 14.5229L0.246643 18.8386L0.532119 16.4708C1.06949 16.5716 2.21139 16.1518 2.63121 14.9595C3.28613 13.1123 4.74709 12.1551 5.50277 11.8696L6.74543 13.7974Z" fill="#2C3236"/>
            <path d="M17.6254 9.0166L24.3257 10.4944L22.193 13.5674L17.659 14.2223H17.6422H17.6254L16.2702 14.9478L15.6606 12.627L17.6254 9.0166Z" fill="#FAFAFA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5818 8.9209L24.4661 10.4392L22.2412 13.6452L17.665 14.3062H17.6465L16.2161 15.0719L15.5 12.5L17.5818 8.9209ZM17.669 9.11208L15.6793 12.5218L16.3244 14.8234L17.6043 14.1383H17.653L22.1449 13.4894L24.1853 10.5493L17.669 9.11208Z" fill="#3F4448"/>
            <path d="M11.5464 8.99976L4.86292 10.7462L6.79408 13.7185L11.5464 14.3063H11.5632H11.58L12.8395 14.9276L13.4776 12.627L11.5464 8.99976Z" fill="#FAFAFA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5894 8.90186L13.6797 12.4803L12.8933 15.0479L11.5605 14.3903H11.5413L6.74504 13.7971L4.72919 10.6945L11.5894 8.90186ZM4.99678 10.7981L6.84326 13.6401L11.5517 14.2224H11.5997L12.7857 14.8075L13.5 12.5L11.5035 9.09786L4.99678 10.7981Z" fill="#3F4448"/>
            <path d="M14.6363 20.9225V20.2004C14.6363 20.15 14.6027 20.0996 14.5523 20.0828C14.5019 20.0996 14.4683 20.15 14.4683 20.2004V20.9225C14.4683 20.956 14.4515 20.9896 14.4347 21.0232C14.4012 21.0736 14.3508 21.1072 14.2836 21.1072H13.9142C13.8134 21.1072 13.6959 21.0736 13.6119 21.0064C13.5783 20.9728 13.5447 20.9393 13.5111 20.8889L13.3264 20.5194C13.2928 20.4523 13.276 20.3683 13.2928 20.3011C13.3096 20.234 13.3432 20.1668 13.3768 20.1164L13.6119 19.7806C13.6791 19.6966 13.7127 19.5958 13.7127 19.4783V19.1592C13.7127 19.0417 13.6455 18.9409 13.5279 18.8905C13.3936 18.8402 13.2425 18.8905 13.1753 19.0249L13.0242 19.3272C12.9738 19.4111 12.8898 19.4783 12.7891 19.4783C12.6379 19.4783 12.5372 19.3607 12.5372 19.2096V18.6051C12.5372 18.4539 12.6043 18.3028 12.7219 18.202L13.5615 17.5135C13.6455 17.4464 13.763 17.396 13.8806 17.396H15.2072C15.3248 17.396 15.4255 17.4296 15.5263 17.5135L16.3659 18.202C16.4835 18.3028 16.5506 18.4539 16.5506 18.6051V19.2096C16.5506 19.3607 16.4331 19.4783 16.2987 19.4783C16.198 19.4783 16.114 19.4279 16.0636 19.3272L15.9125 19.0249C15.8453 18.8905 15.6942 18.8234 15.5599 18.8905C15.4591 18.9409 15.3751 19.0417 15.3751 19.1592V19.4783C15.3751 19.579 15.4087 19.6966 15.4759 19.7806L15.711 20.1164C15.7446 20.1668 15.7782 20.234 15.795 20.3011C15.8117 20.3851 15.795 20.4523 15.7614 20.5194L15.5766 20.8889C15.5599 20.9393 15.5263 20.9728 15.4759 21.0064C15.3919 21.0736 15.2912 21.1072 15.1736 21.1072H14.8042C14.737 21.1072 14.6866 21.0736 14.653 21.0232C14.653 20.9896 14.6363 20.956 14.6363 20.9225Z" fill="#3F4448"/>
            <path d="M14.4851 22.1483C13.9931 22.2121 13.5011 22.2256 13.0057 22.202C12.8831 22.192 12.7521 22.1836 12.6245 22.1433C12.5002 22.103 12.381 22.0459 12.2769 21.9703C12.0653 21.8242 11.9058 21.6227 11.7815 21.4094C11.9578 21.5841 12.1425 21.7436 12.3474 21.8595C12.554 21.9787 12.7723 22.0274 13.0158 22.0341L13.7479 22.0761C13.9931 22.0912 14.2399 22.1147 14.4851 22.1483Z" fill="#5F6467"/>
            <path d="M26.8614 0.116419C27.3484 0.166798 27.701 0.317932 27.9026 0.502652C29.9009 5.89312 28.0537 9.75544 26.9118 11.1324C26.1729 9.386 24.8631 7.5556 23.5029 6.04425C22.8144 5.27178 22.0923 4.58328 21.4542 4.04592C20.8664 3.55893 20.2451 3.27345 19.8253 3.05515C21.79 1.47663 23.654 0.569823 25.0478 0.250761C25.7699 0.0828339 26.3744 0.0492485 26.8614 0.116419Z" fill="#2C3236"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M26.8498 0.199575C26.3755 0.13415 25.7816 0.166271 25.0667 0.332522L25.0664 0.332587C23.7121 0.642621 21.8994 1.51673 19.979 3.03977C20.0016 3.05128 20.0246 3.06301 20.0482 3.07496C20.4538 3.28107 20.9937 3.55545 21.5076 3.98124L21.5081 3.98167C22.1491 4.52147 22.874 5.21268 23.5652 5.98816C24.8958 7.46657 26.1811 9.25238 26.9337 10.9712C28.061 9.52946 29.7561 5.76507 27.8309 0.551305C27.6442 0.388339 27.3161 0.247863 26.8526 0.199917L26.8512 0.19977L26.8498 0.199575ZM26.8713 0.0330282C26.372 -0.0356231 25.7573 -0.000488318 25.0288 0.168927C23.6194 0.491603 21.7441 1.40567 19.7725 2.98967L19.6722 3.07026L19.7864 3.12962C19.8455 3.16036 19.9083 3.19228 19.9741 3.22575C20.38 3.43215 20.902 3.69757 21.4002 4.11034C22.0353 4.6452 22.7544 5.33084 23.4401 6.1001L23.4403 6.1004C24.797 7.60777 26.1004 9.43032 26.8343 11.1651L26.8881 11.2923L26.9763 11.186C28.1353 9.78844 29.991 5.89497 27.9812 0.473446L27.9741 0.454437L27.9592 0.440738C27.7402 0.240038 27.3686 0.0846945 26.8713 0.0330282Z" fill="#CFD0D1"/>
            <path d="M23.4357 11.7704L22.193 13.5672L17.6422 14.2221L18.1124 12.2742L21.387 10.8804L23.4357 11.7704Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3872 10.7891L23.5628 11.7342L22.2412 13.6452L17.5314 14.323L18.0406 12.2135L21.3872 10.7891ZM18.184 12.335L17.7528 14.1215L22.1447 13.4894L23.3084 11.8068L21.3866 10.9719L18.184 12.335Z" fill="#3F4448"/>
            <path d="M7.61694 10.8638L5.58502 11.8545L6.7941 13.7185L11.5632 14.3063L10.9083 12.2576L7.61694 10.8638Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.61443 10.7715L10.9765 12.1952L11.6831 14.4056L6.7449 13.797L5.46289 11.8206L7.61443 10.7715ZM7.61933 10.9559L5.70702 11.8884L6.84317 13.6399L11.4432 14.2068L10.84 12.3198L7.61933 10.9559Z" fill="#3F4448"/>
            <path d="M22.2417 13.6446L17.6455 14.3063L22.9487 14.3231C23.1166 14.3231 23.2677 14.3734 23.4021 14.4742L28.994 18.7563L28.591 16.4893C28.1712 16.6572 26.8614 15.8176 26.5423 14.894C25.8706 12.8789 24.2417 12.0728 23.486 11.7874L22.2417 13.6446Z" fill="#2C3236"/>
            <path d="M25.6355 0.0995884C26.4248 -0.0347534 27.1637 -0.00116795 27.701 0.41865C26.492 0.670541 23.8472 1.82996 22 4.5C21.6977 4.24811 21.1687 3.7772 20.6817 3.50851C20.413 3.35738 20.1779 3.22304 19.9932 3.13907C19.926 3.10549 19.8588 3.0719 19.8253 3.05511C19.8588 3.02152 19.9092 2.98794 19.9764 2.93756C20.1443 2.82001 20.3794 2.65208 20.6649 2.45057C21.2526 2.04754 22.0587 1.54376 22.9319 1.09036C23.8219 0.620163 24.7623 0.23393 25.6355 0.0995884Z" fill="#CFD0D1"/>
            <path d="M2.02495 11.2836C2.78062 9.53713 4.30876 7.11898 5.90407 5.54046C6.72691 4.73441 7.43221 4.12987 8.05354 3.71005C8.3894 3.49175 8.40619 3.44137 8.79242 3.27344C8.85959 3.23985 8.99393 3.18948 9.0611 3.15589C9.01073 3.1391 8.94355 3.08872 8.85959 3.05513C8.65808 2.97117 8.35581 2.83683 8.00316 2.6689C7.29787 2.36663 6.34068 1.96361 5.3667 1.57737C4.39272 1.20793 3.38516 0.855287 2.56232 0.653774C2.15929 0.553018 1.78985 0.485847 1.50437 0.469054C1.37003 0.469054 1.23569 0.469054 1.15173 0.485847C1.06776 0.50264 1.00059 0.452261 0.950211 0.469054C-1.04812 5.87631 0.883041 9.92336 2.02495 11.2836Z" fill="#2C3236"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.05876 0.395974C1.09181 0.404236 1.11336 0.407877 1.13528 0.403494C1.22748 0.385053 1.36808 0.385062 1.49623 0.38507L1.50686 0.385071L1.50932 0.385216C1.8022 0.402444 2.17728 0.470952 2.5825 0.572249C3.41058 0.775061 4.42207 1.12924 5.39649 1.49885L5.39767 1.49929C6.37263 1.88592 7.33058 2.28928 8.03625 2.59171L8.03778 2.59236L8.03927 2.59307C8.39063 2.76039 8.69138 2.89405 8.89136 2.97738C8.93885 2.99643 8.9808 3.01987 9.01412 3.03861C9.05089 3.05929 9.07197 3.07098 9.08767 3.07622L9.27997 3.14032L9.09867 3.23097C9.06248 3.24906 9.01006 3.27091 8.96151 3.29113L8.95907 3.29215C8.90754 3.31362 8.86036 3.33333 8.82998 3.34852L8.82797 3.34952L8.82591 3.35042C8.55513 3.46815 8.47542 3.52352 8.3256 3.62758C8.26659 3.66857 8.19669 3.71712 8.09996 3.78001C7.48476 4.19576 6.78379 4.79623 5.96294 5.60032C4.37646 7.17018 2.85408 9.57881 2.10202 11.3169L2.04805 11.4416L1.96066 11.3375C0.801698 9.95701 -1.13851 5.87871 0.871473 0.439928L0.885444 0.402124L0.923679 0.389379C0.953642 0.379391 0.981938 0.380801 1.00304 0.383815C1.02065 0.386332 1.03909 0.391001 1.05304 0.394533C1.05504 0.39504 1.05695 0.395524 1.05876 0.395974ZM1.00763 0.556282C-0.894802 5.76848 0.874826 9.69306 2.00337 11.1239C2.78014 9.38051 4.27911 7.03019 5.84503 5.48075L5.84533 5.48046C6.66986 4.67276 7.37925 4.06431 8.00655 3.64046L8.00779 3.63962C8.09788 3.58106 8.16537 3.53421 8.22399 3.4935C8.37891 3.38592 8.47193 3.32132 8.75696 3.19729C8.78632 3.18273 8.82579 3.16586 8.86514 3.14939C8.85315 3.14357 8.84095 3.13809 8.82842 3.13307L8.82731 3.13263C8.62454 3.04814 8.32156 2.91346 7.96858 2.74541C7.26395 2.44343 6.30844 2.04113 5.33635 1.65564C4.36308 1.28648 3.35976 0.935489 2.54236 0.735308L2.54197 0.735211C2.14239 0.635315 1.77961 0.569593 1.5019 0.552998C1.36453 0.553003 1.24153 0.553497 1.16821 0.56816C1.10616 0.58057 1.05215 0.567418 1.01803 0.558887C1.01583 0.558337 1.01374 0.557814 1.01177 0.557318C1.01033 0.556959 1.00896 0.556614 1.00763 0.556282Z" fill="#CFD0D1"/>
            <path d="M9.21231 3.13916C8.3055 2.68576 4.98054 0.469116 3.06617 0.217225C2.22654 0.0828834 1.25256 0.0660907 0.883118 0.452323C1.47086 0.586665 2.51201 1.00648 3.56995 1.62781C4.72865 2.31632 5.85377 3.18954 6.81095 4.58333C7.07964 4.33144 8.82608 3.42464 9.21231 3.13916Z" fill="#CFD0D1"/>
            <path d="M20.8495 11.1997L19.0023 11.989C19.0023 12.7782 19.5061 13.7186 20.6816 13.2988C21.9411 12.8454 21.3533 11.5859 20.8495 11.1997Z" fill="#CFD0D1"/>
            <path d="M20.4297 12.8788C20.8007 12.8788 21.1014 12.5781 21.1014 12.2071C21.1014 11.8361 20.8007 11.5354 20.4297 11.5354C20.0587 11.5354 19.758 11.8361 19.758 12.2071C19.758 12.5781 20.0587 12.8788 20.4297 12.8788Z" fill="#2C3236"/>
            <path d="M8.28868 11.25L10.0855 12.0057C10.0855 12.7949 9.59851 13.8025 8.42302 13.3827C7.16357 12.9293 7.7849 11.6362 8.28868 11.25Z" fill="#CFD0D1"/>
            <path d="M9.0107 13.1308C9.38167 13.1308 9.68241 12.83 9.68241 12.4591C9.68241 12.0881 9.38167 11.7874 9.0107 11.7874C8.63972 11.7874 8.33899 12.0881 8.33899 12.4591C8.33899 12.83 8.63972 13.1308 9.0107 13.1308Z" fill="#2C3236"/>
            <path d="M16.2315 15.0619H12.873L13.5447 12.543H15.5598L16.2315 15.0619Z" fill="#3F4448"/>
            <path d="M13.9645 16.5732V17.4129H15.14V16.5732H13.9645Z" fill="#2C3236"/>
            <path d="M16.2315 15.062L15.14 16.5734V17.413L16.2315 15.8177V15.062Z" fill="#2C3236"/>
            <path d="M12.873 15.062L13.9645 16.5734V17.413L12.873 15.8177V15.062Z" fill="#2C3236"/>
            <path d="M13.9645 16.5734L12.873 15.062H16.2315L15.14 16.5734H13.9645Z" fill="#5F6467"/>
            <path d="M19.9427 23.5591C15.8789 24.4659 10.9922 23.9453 9.53122 23.6766L6.91156 27.9924C6.91156 27.9924 11.5684 27.9924 14.5523 27.9924C17.7329 27.9924 22.6967 27.9924 22.6967 27.9924L19.9427 23.5591Z" fill="#5F6467"/>
            <path d="M25.2827 12.9122C24.7621 12.3916 23.9225 11.955 23.4859 11.8039L24.3423 10.6116L24.4599 10.4604L24.208 10.3933L17.5749 8.91552L15.5933 3C17.6252 2.93283 19.2877 2.92051 19.8923 3.08844C25.9712 6.32944 27.9864 13.332 28.5909 16.489C28.5237 16.5058 28.423 16.5226 28.2215 16.4722C28.0199 16.4051 27.7513 16.2707 27.5329 16.1028C27.0795 15.7502 26.7101 15.3807 26.5086 14.7258C26.4246 14.4403 26.2567 14.1381 26.0552 13.8022C25.8369 13.4831 25.585 13.1809 25.2827 12.9122Z" fill="#CFD0D1"/>
            <path d="M2.86458 9.67141C1.35324 12.2575 0.715115 14.9275 0.530396 16.4893C1.4372 16.5228 2.32722 16.0191 2.74704 14.6421C2.84779 14.323 3.53629 13.2483 4.09045 12.7613C4.61103 12.3247 5.09802 12.0224 5.48425 11.8881L4.79575 10.8469L4.69499 10.7126L4.86292 10.6622L11.5296 8.93253L14 3C11.733 3 9.96791 2.88715 9.36337 3.05508C6.37426 4.46567 4.27517 7.05175 2.86458 9.67141Z" fill="#CFD0D1"/>
            <path d="M13.5449 12.5431L11.5 8.91586L13.5113 2.66897C13.5617 2.48425 13.7297 2.3667 13.9144 2.3667H15.1906C15.3753 2.3667 15.5433 2.48425 15.5936 2.66897L17.6677 8.91586L15.5601 12.5431H13.5449Z" fill="#3F4448"/>
          </svg>
      </div>
      <b-popover target="racoon-icon" triggers="hover">
        <span>{{ $t('racoon_header_text') }}!</span>
      </b-popover>

      <div :style="{right: menuRightPosition + 'px'}" ref="menu" class="header-menu">

        <b-form-checkbox v-model="color_theme_flag" :title="$t('toggle_color_theme')" switch id="color-theme" class="grey-switcher color-theme-switcher">
          {{ color_theme_name }}
        </b-form-checkbox>

        <div :class="$store.getters.notifications.length > 0 ? 'notifications-wrapper new-notifications' : 'notifications-wrapper'" :title="$t('notifications.notifications')" @click="show_notifications_modal_window = !show_notifications_modal_window">
          <svg class="notifications-icon" width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.08076 7.28801C5.37619 6.5125 6.11985 6 6.94973 6H11.0503C11.8801 6 12.6238 6.5125 12.9192 7.28801L15.9669 15.288C16.4656 16.5971 15.4987 18 14.0979 18H3.90212C2.50128 18 1.53445 16.5971 2.03314 15.288L5.08076 7.28801Z" fill="#CFD0D1"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 19C7 20.1046 7.89543 21 9 21C10.1046 21 11 20.1046 11 19H7Z" fill="#C4C4C4"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 3.5C11 3.22386 10.7761 3 10.5 3H7.5C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4H10.5C10.7761 4 11 3.77614 11 3.5ZM7 2C6.44772 2 6 2.44772 6 3V4C6 4.55228 6.44772 5 7 5H11C11.5523 5 12 4.55228 12 4V3C12 2.44772 11.5523 2 11 2H7Z" fill="#CFD0D1"/>
          </svg>

          <div class="notifications-label-wrapper">
            <div class="notifications-count-wrapper">
              <span>
                {{ this.$tc('notifications.notifications_count', $store.getters.notifications.length) }}!
              </span>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow">
                <path d="M5 6L0.669873 -8.15666e-07L9.33013 -5.85621e-08L5 6Z" fill="#CFD0D1"></path>
              </svg>
            </div>
          </div>
        </div>

        <b-dropdown class="language-switcher-wrapper" :title="$t('switch_language')">
          <template slot="button-content">
            <div v-html="current_language"></div>

            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow">
              <path d="M5 6L0.669873 -8.15666e-07L9.33013 -5.85621e-08L5 6Z" fill="#CFD0D1"></path>
            </svg>
          </template>

          <b-dropdown-item v-for="(language, index) in languages" :key="index" @click="changeLanguage(language)">
            <div class="lang-icon-wrapper" v-html="language.icon"></div>
            <span>
              {{ language.title }}
            </span>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown class="user-email-wrapper" :title="$t('choose_site')" v-if="$store.getters.getUserData && $store.getters.getUserData.sites && $store.getters.getUserData.sites.length > 0">
          <template slot="button-content">
            <span>
              {{ actual_user_email }}
            </span>

            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow">
              <path d="M5 6L0.669873 -8.15666e-07L9.33013 -5.85621e-08L5 6Z" fill="#CFD0D1"></path>
            </svg>
          </template>

          <b-dropdown-item v-for="(site, index) in $store.getters.getUserData.sites" :key="index" @click="changeSite(site)">
            <span>
              {{ site.domain }}
            </span>
          </b-dropdown-item>
        </b-dropdown>

        <router-link :title="$t('routes.settings')" :to="{ name: 'settings'}" v-if="$store.getters.getUserData && $store.getters.getUserData.permissions.includes('manage_users')">
          <svg id="settings-icon" class="settings" :class="{'settings-active': activeSettings}"
               width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 0.5C14.2761 0.5 14.5 0.723858 14.5 1V5C14.5 5.27614 14.2761 5.5 14 5.5C13.7239 5.5 13.5 5.27614 13.5 5V1C13.5 0.723858 13.7239 0.5 14 0.5Z" fill="#CFD0D1"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0.5C2.27614 0.5 2.5 0.723858 2.5 1V17C2.5 17.2761 2.27614 17.5 2 17.5C1.72386 17.5 1.5 17.2761 1.5 17V1C1.5 0.723858 1.72386 0.5 2 0.5Z" fill="#CFD0D1"/>
            <circle cx="2" cy="5" r="2" fill="#C4C4C4"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0.5C8.27614 0.5 8.5 0.723858 8.5 1V17C8.5 17.2761 8.27614 17.5 8 17.5C7.72386 17.5 7.5 17.2761 7.5 17V1C7.5 0.723858 7.72386 0.5 8 0.5Z" fill="#CFD0D1"/>
            <circle cx="8" cy="13" r="2" fill="#C4C4C4"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 8.5C14.2761 8.5 14.5 8.72386 14.5 9V17C14.5 17.2761 14.2761 17.5 14 17.5C13.7239 17.5 13.5 17.2761 13.5 17V9C13.5 8.72386 13.7239 8.5 14 8.5Z" fill="#CFD0D1"/>
            <path d="M15.25 7C15.25 7.69036 14.6904 8.25 14 8.25C13.3096 8.25 12.75 7.69036 12.75 7C12.75 6.30964 13.3096 5.75 14 5.75C14.6904 5.75 15.25 6.30964 15.25 7ZM14 9.25C15.2426 9.25 16.25 8.24264 16.25 7C16.25 5.75736 15.2426 4.75 14 4.75C12.7574 4.75 11.75 5.75736 11.75 7C11.75 8.24264 12.7574 9.25 14 9.25Z" fill="#CFD0D1" />
          </svg>
        </router-link>

        <div class="education-mode" :title="$t('product_introduction')">
          <svg @click="education_mode = true" width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.491581 2.97513C-0.126937 3.17275 -0.173932 4.04927 0.419752 4.31483L9.62939 8.43437C9.80838 8.51443 10.0119 8.51443 10.1909 8.43437L17.6967 5.07698V8.73295C17.6967 8.97353 18.0136 9.16856 18.4046 9.16856C18.7955 9.16856 19.1124 8.97353 19.1124 8.73295V4.44371L19.4006 4.31483C19.9942 4.04927 19.9472 3.17275 19.3287 2.97513L10.1191 0.0326004C9.98304 -0.0108668 9.83727 -0.0108668 9.70122 0.0326004L0.491581 2.97513ZM18.4046 9.16858L17.3506 11.2764C17.1844 11.6089 17.4261 12.0001 17.7978 12.0001H19.0113C19.383 12.0001 19.6247 11.6089 19.4585 11.2764L18.4046 9.16858ZM4.24719 10.5778V7.0448L9.05134 9.19373C9.59815 9.43832 10.2222 9.43832 10.769 9.19373L15.5731 7.04484V10.5928C15.5731 11.4368 15.0431 12.1901 14.2487 12.4752L10.9975 13.642C10.352 13.8737 9.64669 13.8772 8.99894 13.652L5.5904 12.4669C4.78621 12.1873 4.24719 11.4292 4.24719 10.5778Z" :fill="education_mode ? '#FF4402' : '#C4C4C4'"/>
          </svg>
        </div>

        <div class="log-out" :title="$t('logout')">
          <svg @click="logout" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0H3C1.34315 0 0 1.34315 0 3L0 13C0 14.6569 1.34315 16 3 16H8V0Z" fill="#CFD0D1"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.75 1H10V15H10.75C12.1307 15 13 14.3807 13 13V10.5297C13 10.3226 13.1679 10.1547 13.375 10.1547C13.5821 10.1547 13.75 10.3226 13.75 10.5297V13C13.75 14.6569 12.4069 16 10.75 16H10H9L9 15L9 0.5V0L10 0H10.75C12.4069 0 13.75 1.34315 13.75 3V5.4703C13.75 5.67741 13.5821 5.8453 13.375 5.8453C13.1679 5.8453 13 5.67741 13 5.4703V3C13 1.61929 12.1307 1 10.75 1Z" fill="#CFD0D1"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15 9.81315C15 9.89302 15.089 9.94066 15.1555 9.89635L17.8752 8.0832C17.9346 8.04362 17.9346 7.95638 17.8752 7.91679L15.1555 6.10365C15.089 6.05934 15 6.10698 15 6.18685V6.8453H12.5C12.2239 6.8453 12 7.06916 12 7.3453V8.6547C12 8.93084 12.2239 9.1547 12.5 9.1547H15V9.81315Z" fill="#C4C4C4"/>
          </svg>
        </div>

      </div>

    </div>

    <introductory-training @destroyed="setPageTutorialInfo" v-if="education_mode"></introductory-training>

    <notifications-modal-window :show="show_notifications_modal_window"></notifications-modal-window>

  </div>
</template>

<script>
import IntroductoryTraining from '@/components/main/IntroductoryTraining'
import NotificationsModalWindow from '@/components/custom_ui_components/NotificationsModalWindow'
import { mapActions, mapState } from 'vuex'
import { logout, setCurrentSiteAndTariffToVuex } from '../../utils/index.js'

export default {
  name: 'HeaderComponent',
  components: {
    IntroductoryTraining,
    NotificationsModalWindow
  },
  data () {
    return {
      menuRightPosition: 20,
      color_theme_flag: this.$store.getters.getColorTheme,
      color_theme_name: this.$t('color_switcher.light'),
      color_theme_class: 'color-theme-light',
      languages: [
        {
          key: 'en',
          title: 'English',
          icon: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.7241 13.2414H0.275874C0.123531 13.2414 0 13.1179 0 12.9655V3.03454C0 2.8822 0.123531 2.75867 0.275874 2.75867H15.7241C15.8764 2.75867 16 2.8822 16 3.03454V12.9655C15.9999 13.1179 15.8764 13.2414 15.7241 13.2414Z" fill="#41479B"/><path d="M15.9999 3.03454C15.9999 2.8822 15.8764 2.75867 15.7241 2.75867H14.4898L9.37924 6.107V2.75867H6.62063V6.107L1.51006 2.75867H0.275874C0.123531 2.75867 0 2.8822 0 3.03454V3.74801L4.38464 6.62071H0V9.37933H4.38464L0 12.2521V12.9655C0 13.1179 0.123531 13.2414 0.275874 13.2414H1.51009L6.62069 9.89308V13.2414H9.37931V9.89308L14.4899 13.2414H15.7241C15.8765 13.2414 16 13.1179 16 12.9655V12.2521L11.6154 9.37936H15.9999V6.62075H11.6153L15.9999 3.74801V3.03454Z" fill="#F5F5F5"/><path d="M15.9999 7.17246H8.82756V2.75867H7.17238V7.17246H0V8.82761H7.17238V13.2414H8.82756V8.82761H15.9999V7.17246Z" fill="#FF4B55"/><path d="M5.5921 9.37927L0.0078125 13.0042C0.0273437 13.1374 0.137187 13.2413 0.275843 13.2413H0.65581L6.60547 9.3793H5.5921V9.37927Z" fill="#FF4B55"/><path d="M10.8247 9.37927H9.81128L15.7523 13.2356C15.8908 13.2209 16.0001 13.1078 16.0001 12.9654V12.7386L10.8247 9.37927Z" fill="#FF4B55"/><path d="M0 3.33902L5.05557 6.62069H6.06894L0.160718 2.78552C0.0663435 2.82937 0 2.92358 0 3.03449V3.33902Z" fill="#FF4B55"/><path d="M10.3926 6.62071L15.9903 2.98707C15.9671 2.85826 15.8596 2.75867 15.7241 2.75867H15.3288L9.37927 6.62071H10.3926Z" fill="#FF4B55"/></svg>'
        },
        {
          key: 'ru',
          title: 'Русский',
          icon: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 2.66666H0V13.3334H16V2.66666Z" fill="#0052B4"/><path d="M16 2.66666H0V6.22213H16V2.66666Z" fill="#F0F0F0"/><path d="M16 9.77756H0V13.333H16V9.77756Z" fill="#D80027"/></svg>'
        },
        // {
        //   key: 'de',
        //   title: 'Deutsch',
        //   icon: '<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 5.3796H0V0.551995C0 0.32348 0.185297 0.138184 0.413812 0.138184H23.5862C23.8147 0.138184 24 0.32348 24 0.551995L24 5.3796Z" fill="#464655"/><path d="M23.5861 15.862H0.413812C0.185297 15.862 0 15.6767 0 15.4482V10.6206H24V15.4482C24 15.6767 23.8147 15.862 23.5861 15.862Z" fill="#FFE15A"/><path d="M24 5.37939H0V10.6205H24V5.37939Z" fill="#FF4B55"/></svg>'
        // },
      ],
      current_language: '',
      education_mode: false,
      show_notifications_modal_window: false
    }
  },
  created () {
    this.changeColorTheme()
    this.setLanguage()
    document.addEventListener('keydown', this.hideEducationMode)
  },
  async mounted () {
    await this.FETCH_PAGES_TUTORIALS_INFO()
    this.changeMenuPosition()
    window.addEventListener('resize', this.changeMenuPosition)
    window.addEventListener('scroll', this.changeMenuPosition)

    this.checkNeedShowTutorial()
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMenuPosition)
    document.removeEventListener('scroll', this.changeMenuPosition)
    document.removeEventListener('keydown', this.hideEducationMode)
  },
  watch: {
    color_theme_flag () {
      localStorage.setItem('lh-cp-color-theme', this.color_theme_flag)
      this.changeColorTheme()
    }
  },
  computed: {
    ...mapState('training', ['tutorials']),
    activeSettings () {
      return this.$route.meta.menu && this.$route.meta.menu.includes('settings')
    },
    actual_user_email () {
      let site_index = this.$store.getters.getUserData.sites.findIndex(function(site) {
        if(site.id === this.$store.getters.getSiteId) return true
      }.bind(this))

      if(site_index !== -1) {
        return this.$store.getters.getUserData.sites[site_index].domain
      }
      else {
        return this.$store.getters.getUserData.sites[0].domain
      }
    }
  },
  methods: {
    ...mapActions('training', ['FETCH_PAGES_TUTORIALS_INFO', 'SET_PAGE_TUTORIAL_INFO']),
    async setPageTutorialInfo() {
      if (this.tutorials['interface_details']) {
        return
      }
      await this.SET_PAGE_TUTORIAL_INFO('interface_details')
    },
    checkNeedShowTutorial() {
      if (!this.tutorials['interface_details']) {
        this.education_mode = true
      }
    },
    changeMenuPosition() {
      if (window.innerWidth > 1520) {
        this.menuRightPosition = 20
        return
      }

      this.menuRightPosition = 1550 - window.innerWidth - window.pageXOffset

      if (this.menuRightPosition > 620) {
        this.menuRightPosition = 620
      }
    },
    hideEducationMode (event) {
      if (event.keyCode === 27) {
        this.education_mode = false
      }
    },
    logout () {
      logout()
    },
    changeLanguage (language) {
      this.$i18n.locale = language.key
      this.current_language = language.icon
      localStorage.setItem('lh-cp-language', language.key)
      this.$store.commit('toggleLanguage', language.key)
    },
    changeSite (site) {
      if(site.id === this.$store.getters.getSiteId) return
      localStorage.setItem('lh-cp-site-id', site.id)
      this.$store.commit('setSiteId', site.id)

      if(this.$raven && this.$raven.setExtraContext) {
        this.$raven.setExtraContext()
        this.$raven.setExtraContext({site_id: site.id})
        this.$raven.setExtraContext({site_domain: this.$store.getters.getSiteNameById(site.id)})
      }

      setCurrentSiteAndTariffToVuex.call(this)

      if(this.$router.currentRoute.meta && this.$router.currentRoute.meta.menu &&
        Array.isArray(this.$router.currentRoute.meta.menu)) {

        if(this.$router.currentRoute.meta.menu.includes('Desktop')) {
          this.$router.push({ name: 'Desktop' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('settings')) {
          this.$router.push({ name: 'settings' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('leads')) {
          this.$router.push({ name: 'leads' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('reports')) {
          this.$router.push({ name: 'reports' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('analytics')) {
          this.$router.push({ name: 'analytics' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('integration')) {
          this.$router.push({ name: 'integration' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('library')) {
          this.$router.push({ name: 'library' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('instruments')) {
          this.$router.push({ name: 'instruments' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('settings')) {
          this.$router.push({ name: 'settings' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('settings')) {
          this.$router.push({ name: 'settings' })
        }
      }
      else {
        this.$router.go()
      }
      window.location.reload(true)
    },
    setLanguage () {
      let current_language_index = this.languages.findIndex(function(language) {
        if(language.key === this.$i18n.locale) return true
      }.bind(this))
      this.current_language = this.languages[current_language_index].icon
      this.changeLanguage(this.languages[current_language_index])
    },
    changeColorTheme () {
      this.color_theme_name = this.color_theme_flag ? this.$t('color_switcher.dark') : this.$t('color_switcher.light')
      this.color_theme_class = this.color_theme_flag ? 'color-theme-dark' : 'color-theme-light'
      this.$store.commit('toggleColorTheme', this.color_theme_flag)
    }
  }
}
</script>

<style lang="scss">

.color-theme-dark {
  background: #3F4448 !important;
  color: #CFD0D1 !important;

  li.breadcrumb-item a {
    color: #CFD0D1 !important;
  }
  li.breadcrumb-item.active span {
    border-bottom: 1px solid #CFD0D1 !important;
    color: #CFD0D1 !important;
  }
  transition: .3s;
  .card:hover {
    box-shadow: unset !important;
    border: 1px solid #CFD0D1;
    transition: border .5s;
  }
  .detailed {
    color: #CFD0D1 !important;
    text-decoration: none !important;
  }
  .detailed:hover {
    background: #CFD0D1 !important;
    border: 1px solid #CFD0D1 !important;
    color: #2C3236 !important;
  }
  .detailed:active {
    border: 1px solid #CFD0D1 !important;
    box-shadow: 0 0 0 0.2rem rgba(207, 208, 209, 0.5);
  }

  .analytic-wrapper {
    background: #2C3236 !important;

    .resize-icon {

      svg path {
        fill: #CFD0D1;
      }
    }
  }
  .wrapper-header {
    .dropdown.b-dropdown.show {

      button {
        color: #5F6467 !important;
      }
      ul.dropdown-menu {
        background: #3F4448 !important;
        border: 1px solid #CFD0D1 !important;

        .dropdown-item {
          color: #CFD0D1;
          border: unset;
        }
        .dropdown-item:hover, .active {
          background: #2C3236;
        }
      }
    }
    .multiselected-item {
      background: #CFD0D1;
      color: #2C3236;

      .multiselect-close-icon path{
        fill: #2C3236;
      }
    }
  }
}
.color-theme-light {
  background: white !important;
  color: #5F6467 !important;
  transition: .3s;
}

.wrapper-header {
  width: 100%;
  position: relative;
  right: 0;
  height: max-content;
  min-width: 900px;
}
#header {
  height: 60px;
  background: #2C3236;
  width: 100%;
  color: #CFD0D1;
  font-size: 12px;
}
#racoon-icon {
  position: absolute;
  left: 50px;
  bottom: 0;
}

.header-menu {
  position: absolute;
  bottom: 20px;
  /*right: 20px;*/
  display: flex;
  align-items: flex-end;
  width: fit-content;

  .custom-control.custom-switch.grey-switcher {
    width: 90px;
    line-height: 21px;
    display: flex;
    align-items: flex-end;
  }
  .language-switcher-wrapper {
    margin-left: 30px;
    width: fit-content !important;

    .dropdown-menu {
      margin-top: 15px;
      color: #212529;

      li a {
        color: #212529;
        font-size: 12px;
      }
      li:not(:last-child) {
        border-bottom: 1px solid #CFD0D1;
      }
      li:hover a {
        background: rgba(207, 208, 209, 0.3);
      }
    }
    .arrow {
      margin-left: 10px;
    }
    .dropdown-toggle {
      padding: 0 !important;
      background: transparent !important;
      border: unset !important;
      box-shadow: unset !important;
      display: flex !important;
      align-items: center;
    }
    .dropdown-toggle:focus {
      border: unset !important;
    }
    .dropdown-toggle::after {
      display: none !important;
    }
    .dropdown-item {
      display: flex;
      align-items: center;
    }
    .lang-icon-wrapper {
      display: flex;
      align-items: center;
      margin-right: 10px;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
  .notifications-wrapper {
    margin-left: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .notifications-label-wrapper {
      margin-left: 10px;

      svg {
        margin-left: 10px;
        margin-bottom: 3px;
      }
    }
  }
  .notifications-wrapper.new-notifications {

    .notifications-icon {
      path {
        fill: #FF4402;
      }
    }
    .notifications-count-wrapper {
      color: #FF4402;

      svg path {
        fill: #FF4402;
      }
    }
  }
  .log-out, .settings {
    margin-left: 30px;
    min-width: 18px;
  }
  .education-mode {
    margin-left: 30px;
    margin-bottom: 1px;
  }
  .log-out:hover, .settings:hover, .settings-active, .education-mode:hover {
    cursor: pointer;

    path, circle {
      fill: #FF4402 !important;
    }
  }
  .user-email-wrapper {
    margin-left: 30px;

    .dropdown-toggle > span {
      font-size: 12px;
      color: #CFD0D1;
    }
    .dropdown-menu {
      margin-top: 15px;

      li a {
        color: #212529;
        font-size: 12px;
      }
      li:not(:last-child) {
        border-bottom: 1px solid #CFD0D1;
      }
      li:hover a {
        background: rgba(207, 208, 209, 0.3);
      }
    }
    .arrow {
      margin-left: 10px;
      margin-bottom: 3px;
    }
    .dropdown-toggle {
      padding: 0 !important;
      background: transparent !important;
      border: unset !important;
      box-shadow: unset !important;
      display: flex !important;
      align-items: center;
    }
    .dropdown-toggle::after {
      display: none !important;
    }
  }
}
.header-color-theme-dark {
  .header-menu {

    .language-switcher-wrapper, .user-email-wrapper {

      .dropdown-menu {
        background: #2C3236;
        border-color: #5F6467;
        color: #CFD0D1;

        li a {
          color: #CFD0D1;
        }
        li {
          border-color: #5F6467;
        }
        li:hover a {
          background: #3F4448;
        }
      }
    }

  }
}

/*@media (max-width: 754px) {*/
/*  .header-menu {*/
/*    position: absolute;*/
/*    left: 123px;*/
/*    right: unset;*/
/*  }*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/components/main/HeaderComponent.vue